import moment from "moment";
import { Cell, Row } from "react-table";
import { AssignedContractModel } from "src/api/contractGroup/contractgroup-type";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import ContractStatusChip from "src/components/contract/ContractStatusChip";
import ProductTypeChangeLabel from "src/components/ProductTypeChangeLabel";
import { PagePath } from "src/pages/product/details";
import { ViewYmdFormat } from "src/utils";
import { getContractDetailPath } from "src/utils/route-util";

export const AssignedContractColumns = [
  {
    Header: "계약 ID", //
    accessor: "contractGroupMap",
    width: 80,
    Cell: ({ row, value }: Cell<AssignedContractModel>) => {
      const id = value.contractId;
      return <BaseNewTabLink path={getContractDetailPath({ contractId: id })} value={id} className="w-100" />;
    },
  },
  {
    Header: "신청번호", //
    accessor: "contractApplyNumber",
    width: 120,
    Cell: ({ row }: Cell<AssignedContractModel>) => {
      const id = row.original.contractGroupMap.contractId;
      return <BaseNewTabLink path={getContractDetailPath({ contractId: id })} value={row.original.contractApplyNumber} className="w-100" />;
    },
  },
  {
    Header: "상품 유형", //
    accessor: "spaceProductType",
    width: 80,
    Cell: ({ value }: Cell<AssignedContractModel>) => <ProductTypeChangeLabel productType={value} />,
  },
  {
    Header: "상태", //
    accessor: "contractStep",
    width: 80,
    Cell: ({ value }: Cell<AssignedContractModel>) => <ContractStatusChip status={value} />,
  },
  {
    Header: "계약명", //
    accessor: "contractName",
    width: 240,
    Cell: ({ value }: Cell<AssignedContractModel>) => <span>{value || "-"}</span>,
  },
  {
    Header: "계약자 (법인명/상호)", //
    accessor: "orgName",
    width: 160,
    Cell: ({ row }: Cell<AssignedContractModel>) => {
      return row.original.mbOrganizationId ? (
        <BaseNewTabLink
          className="minmax110"
          path={PagePath.organization.detail.replace(":id", String(row.original.mbOrganizationId))}
          value={row.original.orgName || "-"}
          tooltip
          ellipsis
          isSingleLine
        />
      ) : (
        <span>{row.original.orgName || "-"}</span>
      );
    },
  },
  {
    Header: "상품명", //
    accessor: "spaceProductName",
    width: 200,
    Cell: ({ row }: Cell<AssignedContractModel>) => {
      return (
        <BaseNewTabLink
          className="minmax160"
          path={PagePath.product.detail.replace(":id", String(row.original.spaceProductId))}
          value={row.original.spaceProductName || "-"}
          tooltip
        />
      );
    },
  },
  {
    Header: "이용자(현재/최대)", //
    accessor: "memberNums",
    width: 120,
    Cell: ({ row }: Cell<AssignedContractModel>) => {
      const memberNums = row.original.memberNums;
      const memberMaxNums = row.original.memberMaxNums;
      const contractApplyNumber = row.original.contractApplyNumber;
      const contractId = row.original.contractGroupMap.contractId;
      const path = PagePath.user.list + "?contractApplyNumber=" + contractApplyNumber + "&contractId=" + contractId;

      return <BaseNewTabLink path={path} value={`${memberNums}/${memberMaxNums}`} />;
    },
  },
  {
    Header: "계약시작일", //
    accessor: "contractStartDate",
    width: 120,
    // 요일 제거: 2025-12-19(금) → 2025-12-19
    Cell: ({ value }: Cell<AssignedContractModel>) => {
      return value ? <span>{moment(value).format(ViewYmdFormat.YYYY_MM_DD)}</span> : <span>-</span>;
    },
  },
  {
    Header: "계약종료일", //
    accessor: "contractEndDate",
    width: 120,
    // 요일 제거: 2025-12-19(금) → 2025-12-19
    Cell: ({ value }: Cell<AssignedContractModel>) => {
      return value ? <span>{moment(value).format(ViewYmdFormat.YYYY_MM_DD)}</span> : <span>-</span>;
    },
  },
  {
    Header: "삭제", //
    accessor: "",
    width: 80,
    Cell: ({
      row,
      handleDeleteContract,
    }: {
      row: Row<AssignedContractModel>;
      handleDeleteContract: (contract: AssignedContractModel) => Promise<void>;
    }) => <button className="base-trash-btn color-gray border-none" onClick={() => handleDeleteContract(row.original)} />,
  },
];
